<template>
  <div class="py-6 font-semibold px-6">
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
          updateUserCountry()
        }
      "
    />
    <AppDataProperty
      contentId="addresses"
      @dataAvailable="
        data => {
          addresses = data || {}
        }
      "
    />
    
    <AppDataProperty
      contentId="appInfo"
      @dataAvailable="
        data => {
          appInfo = data || {}
        }
      "
    />
    <AppDataProperty
      contentId="subscription"
      @dataAvailable="
        data => {
          subscription = data?.metaData || {}
        }
      "
    />
    <div>
      <div class="flex flex-col items-center justify-center">
        <FileUploader
          :acceptedFilesTypes="['image/png', 'image/jpeg']"
          :makeLoadingModal="false"
          ref="profilePicUploader"
          @onFileChanged="onProfilePictureUploaded"
        >
          <div></div>
        </FileUploader>
        <div
          class="w-24 h-24 relative flex items-center justify-center"
          @click="
            () => {
              $refs.profilePicUploader.selectFile()
            }
          "
        >
          <img
            :src="userData.profilePictureUrl || '/images/icons/logo.png'"
            alt=""
            class="w-full h-full rounded-full ripple object-cover"
          />

          <button
            class="absolute py-1 px-2 -bottom-4 rounded-full ripple"
            @click="vipButtonClicked"
            :class="{
              bgGradientLight: subscription.isActive,
              glassBg: !subscription.isActive,
            }"
          >
            <div
              class="w-7 right-2 absolute translate-x-2/3 -translate-y-full"
              v-if="subscription.isActive"
            >
              <img
                src="@/assets/images/king-recharge-assets/crown-white.svg"
                class="w-full"
                alt=""
              />
            </div>
            <div class="relative">
              <div>
                Compte&nbsp;{{ subscription.isActive ? 'VIP' : 'STANARD' }}
              </div>
            </div>
          </button>
        </div>
        <div class="py-3"></div>
        <div class="text-center title-color text-2xl font-bold">
          {{ userData.firstName }}
          {{ userData.lastName }}
        </div>
        <div class="py-1"></div>
      </div>
      <div class="py-4"></div>
      <div>
        <div class="text-white font-bold text-lg">
          {{ $t('profile.accountSection.title') }}
        </div>
        <div class="py-2"></div>
        <div class="flex gap-4 items-center">
          <div class="w-12 h-12 border p-3 bg-[#F5F5F5] rounded-full">
            <img src="@/assets/images/all/location.svg" alt="" />
          </div>
          <div>
            <div class="text-xs">
              {{ $t('profile.accountSection.countryLabel') }}
            </div>
            <div class="title-color text-md">
              {{ userCountry?.countryFlag }}
              {{ userCountry?.countryName }}
            </div>
          </div>
        </div>
        <div class="py-2"></div>
        <div class="flex gap-4 items-center">
          <div class="w-12 h-12 border p-3 bg-[#F5F5F5] rounded-full">
            <img src="@/assets/images/all/phone-call.svg" alt="" />
          </div>
          <div>
            <div class="text-xs">
              {{ $t('profile.accountSection.phoneNumberLabel') }}
            </div>
            <div class="title-color text-md">
              {{ userData?.metaData?.phoneNumber }}
            </div>
          </div>
          <button class="ml-auto w-6 h-6 ripple" @click="editPhoneNumber">
            <img src="@/assets/images/all/writing-white.svg" alt="" />
          </button>
        </div>
        <div class="py-2"></div>
        <div class="flex gap-4 items-center">
          <div class="w-12 h-12 border p-3 bg-[#F5F5F5] rounded-full">
            <img src="@/assets/images/all/betting.svg" alt="" />
          </div>
          <div>
            <div class="text-xs">Identifiants Bookmakers</div>
            <div class="title-color text-md">1xBet, Betwinner, Melbet, 888Starz et 1Win</div>
          </div>
          <button class="ml-auto w-6 h-6 ripple" @click="setAccountId">
            <img src="@/assets/images/all/writing-white.svg" alt="" />
          </button>
        </div>
        <div class="py-2"></div>
        <div class="flex gap-4 items-center ripple" @click="setColorTheme" v-if="userData?.email=='test@gmail.com'">
          <div class="w-12 h-12 border p-3 bg-[#F5F5F5] rounded-full">
            <img src="@/assets/images/all/theme.svg" alt="" />
          </div>
          <div>
            <div class="text-xs">Theme</div>
            <div class="title-color text-md">Changer le theme de kingrecharges</div>
          </div>
          <!-- <button class="ml-auto w-6 h-6 ripple" >
            <img src="@/assets/images/all/writing-white.svg" alt="" />
          </button> -->
        </div>
      </div>
      <div class="py-4"></div>
      <div>
        <div class="text-white font-bold text-lg">
          {{ $t('profile.contactSection.title') }}
        </div>
        <div class="py-2"></div>
        <div class="flex gap-4 flex-col">
          <div v-for="(content, i) in contactContents" :key="i">
            <a
              target="_blank"
              :href="
                (content.id == 'email' ? 'mailto:' : '') +
                (appInfo?.metaData || {})[content.id]
              "
              class="flex gap-4 items-center"
            >
              <div class="w-12 h-12 border p-3 bg-[#F5F5F5] rounded-2xl">
                <img :src="content.icon" alt="" />
              </div>
              <div>
                <div class="title-color text-md">
                  {{ content.name }}
                  <span v-if="content.id == 'email'">
                    : {{ (appInfo?.metaData || {})[content.id] }}
                  </span>
                </div>
              </div>
              <div
                class="flex ml-auto items-center gap-2 text-[#AFB7C4]"
                v-if="content.id !== 'email'"
              >
                <div class="text-sm">{{ content.actionText }}</div>
                <div class="w-3 h-3">
                  <img src="@/assets/images/all/right-arrow-slate.svg" alt="" />
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="py-4"></div>
      <div
        class="overflow-hidden"
      >
        <div class="text-white font-bold text-lg">
          {{ $t('profile.networksSection.title') }}
        </div>
        <div class="py-2"></div>
        <div
          class="flex flex-col relative duration-300"
          :style="{
            height: `${4 * (networksCollapsed ? 1 : networksContents.length)}rem`,
          }"
        >
          <div v-for="(content, i) in networksContents" :key="i" class="">
            <a
              target="_blank"
              :href="(appInfo?.metaData || {})[content.id]"
              class="flex gap-4 items-center absolute w-full py-2 h-[4rem] duration-300"
              @click.stop
              :class="{
                'pointer-events-none': networksCollapsed,
                'opacity-0': i > 3 && networksCollapsed,
              }"
              :style="{
                top: `${i * 4}rem`,
                transform: `translateY(-${100 * (networksCollapsed ? i : 0)}%) translateX(${4 * (networksCollapsed ? i : 0)}rem)`,
              }"
            >
              <div class="w-12 h-12 border p-3 bg-[#F5F5F5] rounded-2xl">
                <img :src="content.icon" alt="" />
              </div>
              <div
                class="duration-300"
                :class="{ 'opacity-0': networksCollapsed }"
              >
                <div class="title-color text-md">
                  {{ content.name }}
                </div>
              </div>
              <div
                class="flex ml-auto items-center gap-2 duration-300 text-[#AFB7C4]"
                :class="{ 'opacity-0': networksCollapsed }"
              >
                <div class="text-sm">{{ content.actionText }}</div>
                <div class="w-3 h-3">
                  <img src="@/assets/images/all/right-arrow-slate.svg" alt="" />
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="py-4"></div>
      <div>
        <div class="text-white font-bold text-lg">Aides & Assistance</div>
        <div class="py-2"></div>
        <div class="flex gap-4 flex-col">
          <div
            v-for="(content, i) in helpContents"
            :key="i"
            v-show="!content.isLink || (appInfo?.metaData || {})[content.id]"
          >
            <component
              :is="content.isLink ? 'a' : 'div'"
              target="_blank"
              :href="(appInfo?.metaData || {})[content.id]"
              class="flex gap-4 items-center ripple"
              @click="
                () => {
                  if (content.id == 'rechargeHelp') rechargeHelpClick()
                  if (content.id == 'withdrawHelp') withdrawHelpClick()
                }
              "
            >
              <div class="w-12 h-12 border p-2 bg-[#F5F5F5] rounded-2xl">
                <img
                  :src="content.icon"
                  alt=""
                  class="object-contain w-full h-full"
                />
              </div>
              <div>
                <div class="title-color text-md">
                  {{ content.name }}
                </div>
              </div>
              <div class="flex ml-auto items-center gap-2 text-[#AFB7C4]">
                <div class="text-sm">{{ content.actionText }}</div>
                <div class="w-3 h-3">
                  <img src="@/assets/images/all/right-arrow-slate.svg" alt="" />
                </div>
              </div>
            </component>
          </div>
        </div>
      </div>
      <div class="py-4"></div>
      <div class="overflow-hidden" >
        <div class="text-white font-bold text-lg">Applications</div>
        <div class="py-2"></div>
        <div
          class="flex gap-4 flex-col duration-300 relative"
          :style="{
            height: `${4 * (appsCollapsed ? 1 : appsContentsFiltered.length)}rem`,
          }"
        >
          <div v-for="(content, i) in appsContentsFiltered" :key="i">
            <a
              target="_blank"
              :href="(appInfo?.metaData || {})[content.id]"
              class="flex gap-4 items-center ripple absolute w-full py-2 h-[4rem] duration-300"
              @click.stop
              :class="{
                'pointer-events-none': appsCollapsed,
                'opacity-0': i > 3 && appsCollapsed,
              }"
              :style="{
                top: `${i * 4}rem`,
                transform: `translateY(-${100 * (appsCollapsed ? i : 0)}%) translateX(${4 * (appsCollapsed ? i : 0)}rem)`,
              }"
            >
              <div class="w-12 h-12 border p-2 bg-[#F5F5F5] rounded-2xl">
                <img
                  :src="content.icon"
                  alt=""
                  class="object-contain w-full h-full"
                />
              </div>
              <div class="duration-300" :class="{ 'opacity-0': appsCollapsed }">
                <div class="title-color text-md">
                  {{ content.name }}
                </div>
              </div>
              <div
                class="duration-300 flex ml-auto items-center gap-2 text-[#AFB7C4]"
                :class="{ 'opacity-0': appsCollapsed }"
              >
                <div class="text-sm">{{ content.actionText }}</div>
                <div class="w-3 h-3">
                  <img src="@/assets/images/all/right-arrow-slate.svg" alt="" />
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="py-4"></div>
      <div>
        <div class="text-white font-bold text-lg">
          {{ $t('profile.privacySection.title') }}
        </div>
        <div class="py-2"></div>
        <div class="flex gap-4 flex-col">
          <div v-for="(content, i) in privacyContents" :key="i">
            <a
              target="_blank"
              :href="(appInfo?.metaData || {})[content.id]"
              class="flex gap-4 items-center"
            >
              <div class="w-12 h-12 border p-3 bg-[#F5F5F5] rounded-2xl">
                <img :src="content.icon" alt="" />
              </div>
              <div>
                <div class="title-color text-md">
                  {{ content.name }}
                </div>
              </div>
              <div class="flex ml-auto items-center gap-2 text-[#AFB7C4]">
                <div class="text-sm">{{ content.actionText }}</div>
                <div class="w-3 h-3">
                  <img src="@/assets/images/all/right-arrow-slate.svg" alt="" />
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="py-4"></div>
      <div>
        <div class="text-white font-bold text-lg">
          {{ $t('profile.moreSection.title') }}
        </div>
        <div class="py-2"></div>
        <div class="flex gap-4 flex-col">
          <div>
            <button
              @click="requestLogout"
              class="flex gap-4 items-center w-full"
            >
              <div class="w-12 h-12 border p-3 bg-[#F5F5F5] rounded-2xl">
                <img src="@/assets/images/all/logout.svg" alt="" />
              </div>
              <div>
                <div class="title-color text-md">
                  {{ $t('profile.logout') }}
                </div>
              </div>
              <div class="flex ml-auto items-center gap-2 text-[#AFB7C4]">
                <div class="w-3 h-3">
                  <img src="@/assets/images/all/right-arrow-slate.svg" alt="" />
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div class="py-4"></div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import UserProperty from '../user/UserProperty.vue'

import faqUrlIcon from '@/assets/images/all/help.svg'
import whatsappLinkIcon from '@/assets/images/all/whatsapp.svg'
import telegramLinkIcon from '@/assets/images/all/telegram_1.svg'
import instagramLinkIcon from '@/assets/images/all/instagram_1.svg'
import facebookLinkIcon from '@/assets/images/all/facebook-app-symbol.svg'
import tiktokLinkIcon from '@/assets/images/all/tik-tok.svg'
import websiteLinkIcon from '@/assets/images/all/www.svg'
import policyUrlIcon from '@/assets/images/all/file.svg'
import netflixIcon from '@/assets/images/all/netflix.svg'
import disneyIcon from '@/assets/images/all/disney-plus.svg'
import crunchyrollIcon from '@/assets/images/all/crunchyroll.svg'
import nordvpnIcon from '@/assets/images/all/nordvpn.svg'
import primeVideoIcon from '@/assets/images/all/prime-video.svg'
import spotifyIcon from '@/assets/images/all/spotify.svg'
import privatevpnIcon from '@/assets/images/all/privatevpn.png'
import oneWinIcon from '@/assets/images/all/1winIcon-gray.svg'
import xBetIcon from '@/assets/images/all/1xBetIco.svg'
import betwinnerIcon from '@/assets/images/all/betwinner.png'
import melbetIcon from '@/assets/images/all/melbetIcon.svg'
import eightStarzIcon from '@/assets/images/all/eightStarz.png'
import adnIcon from '@/assets/images/all/adn.svg'
import cyberghostIcon from '@/assets/images/all/cyberghost.webp'
import emailLinkIcon from '@/assets/images/all/email.svg'
import cguUrlIcon from '@/assets/images/all/terms-and-conditions.svg'
import AppDataProperty from './AppDataProperty.vue'
import ModalComponentFullScreen from '../utils/ModalComponentFullScreen.vue'
import VipPresentation from './Coupons/VipPresentation.vue'

export default defineComponent({
  name: 'ProfileContent',
  components: {
    UserProperty,
    AppDataProperty,
    ModalComponentFullScreen,
    VipPresentation,
  },
  props: {},
  data() {
    return {
      networksCollapsed: false,
      appsCollapsed: false,
      userData: {},
      appInfo: {},
      userCountry: {},
      addresses: {},
      subscription: {},
      contactContents: [
        {
          id: 'whatsappAssistanceLink',
          name: this.$t('profile.contactSection.whatsapp'),
          icon: whatsappLinkIcon,
          actionText: this.$t('profile.contactSection.whatsappActionText'),
        },
        {
          id: 'telegramAssistanceLink',
          name: this.$t('profile.contactSection.telegram'),
          icon: telegramLinkIcon,
          actionText: this.$t('profile.contactSection.telegramActionText'),
        },
        {
          id: 'email',
          name: this.$t('profile.contactSection.email'),
          icon: emailLinkIcon,
          actionText: this.$t('profile.contactSection.emailActionText'),
        },
      ],
      networksContents: [
        {
          id: 'whatsappLink',
          name: this.$t('profile.networksSection.whatsapp'),
          icon: whatsappLinkIcon,
          actionText: this.$t('profile.networksSection.whatsappActionText'),
        },
        {
          id: 'telegramLink',
          name: this.$t('profile.networksSection.telegram'),
          icon: telegramLinkIcon,
          actionText: this.$t('profile.networksSection.telegramActionText'),
        },
        {
          id: 'instagramLink',
          name: this.$t('profile.networksSection.instagram'),
          icon: instagramLinkIcon,
          actionText: this.$t('profile.networksSection.instagramActionText'),
        },
        {
          id: 'facebookLink',
          name: this.$t('profile.networksSection.facebook'),
          icon: facebookLinkIcon,
          actionText: this.$t('profile.networksSection.facebookActionText'),
        },
        {
          id: 'tiktokLink',
          name: this.$t('profile.networksSection.tiktok'),
          icon: tiktokLinkIcon,
          actionText: this.$t('profile.networksSection.tiktokActionText'),
        },
        {
          id: 'websiteLink',
          name: this.$t('profile.networksSection.website'),
          icon: websiteLinkIcon,
          actionText: this.$t('profile.networksSection.websiteActionText'),
        },
      ],
      helpContents: [
        {
          id: 'faqUrl',
          isLink: true,
          name: 'F.A.Q.',
          icon: faqUrlIcon,
          actionText: 'Visiter',
        },
        {
          id: 'rechargeHelp',
          isLink: false,
          name: 'Comment faire un dépot ?',
          icon: faqUrlIcon,
          actionText: 'Voir',
        },
        {
          id: 'withdrawHelp',
          isLink: false,
          name: 'Comment Faire un retrait ?',
          icon: faqUrlIcon,
          actionText: 'Voir',
        },
      ],
      appsContents: [
        {
          id: 'xbetDownloadUrl',
          isLink: true,
          name: 'Télécharger 1Xbet',
          icon: xBetIcon,
          actionText: 'Télécharger',
        },
        {
          id: 'betwinnerDownloadUrl',
          isLink: true,
          name: 'Télécharger Betwinner',
          icon: betwinnerIcon,
          actionText: 'Télécharger',
        },
        {
          id: 'melbetDownloadUrl',
          isLink: true,
          name: 'Télécharger Melbet',
          icon: melbetIcon,
          actionText: 'Télécharger',
        },
        {
          id: 'eightStarzDownloadUrl',
          isLink: true,
          name: 'Télécharger 888Starz',
          icon: eightStarzIcon,
          actionText: 'Télécharger',
        },
        {
          id: 'oneWinDownloadUrl',
          isLink: true,
          name: 'Télécharger OneWin',
          icon: oneWinIcon,
          actionText: 'Télécharger',
        },
        {
          id: 'netflixDownloadUrl',
          isLink: true,
          name: 'Télécharger Netflix',
          icon: netflixIcon,
          actionText: 'Télécharger',
        },
        {
          id: 'primeVideoDownloadUrl',
          isLink: true,
          name: 'Télécharger PrimeVideo',
          icon: primeVideoIcon,
          actionText: 'Télécharger',
        },
        {
          id: 'disneyDownloadUrl',
          isLink: true,
          name: 'Télécharger Disney',
          icon: disneyIcon,
          actionText: 'Télécharger',
        },
        {
          id: 'crunchyrolDownloadUrl',
          isLink: true,
          name: 'Télécharger Crunchyrol',
          icon: crunchyrollIcon,
          actionText: 'Télécharger',
        },
        {
          id: 'spotifyDownloadUrl',
          isLink: true,
          name: 'Télécharger Spotify',
          icon: spotifyIcon,
          actionText: 'Télécharger',
        },
        {
          id: 'nordVPNDownloadUrl',
          isLink: true,
          name: 'Télécharger NordVPN',
          icon: nordvpnIcon,
          actionText: 'Télécharger',
        },
        {
          id: 'privateVPNDownloadUrl',
          isLink: true,
          name: 'Télécharger PrivateVPN',
          icon: privatevpnIcon,
          actionText: 'Télécharger',
        },
        {
          id: 'cyberGhostDownloadUrl',
          isLink: true,
          name: 'Télécharger CyberGhost',
          icon: cyberghostIcon,
          actionText: 'Télécharger',
        },
        {
          id: 'adnDownloadUrl',
          isLink: true,
          name: 'Télécharger Adn',
          icon: adnIcon,
          actionText: 'Télécharger',
        },
      ],
      privacyContents: [
        {
          id: 'policyUrl',
          name: this.$t('profile.privacySection.policy'),
          icon: policyUrlIcon,
          actionText: this.$t('profile.privacySection.policyActionText'),
        },
        {
          id: 'cguUrl',
          name: this.$t('profile.privacySection.cgu'),
          icon: cguUrlIcon,
          actionText: this.$t('profile.privacySection.cguActionText'),
        },
      ],
    }
  },
  mounted() {},
  methods: {
    vipButtonClicked() {
      if (this.subscription.isActive) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Abonnement VIP Actif',
          body: 'Vous êtes un abonné VIP',
          type: 'success',
        })
      } else {
        this.$Events.dispatchEvent('vip_subscription_section_display_required')
      }
    },
    requestLogout() {
      this.$Events.dispatchEvent('logout_requested')
    },
    async setAccountId() {
      const acocuntIdsPreferencesConfig = [
        {
          dataToSet: 'xbetAccountId',
          name: '1xBet',
        },
        {
          dataToSet: 'betwinnerAccountId',
          name: 'Betwinner',
        },
        {
          dataToSet: 'melbetAccountId',
          name: 'Melbet',
        },
        {
          dataToSet: 'eightStarzAccountId',
          name: '888Starz',
        },
        {
          dataToSet: 'oneWinAccountId',
          name: '1Win',
        },
      ]
      const prompt = await window.choicePrompt({
        title: this.$t('profile.modifyIdentifier'),
        // subTitle: "Donnez la raison du rejet de l'opération",
        options: acocuntIdsPreferencesConfig,
        // defaultOption: acocuntIdsPreferencesConfig[0],
        formatDisplay: data => data?.name || '',
        successText: this.$t('profile.modify'),
      })
      if (!prompt.accepted || !prompt.data) return
      this.$Events.dispatchEvent('preference_update_requested', prompt.data)
    },
    async setColorTheme() {
      const prompt = await window.choicePrompt({
        title: this.$t('profile.modifyColorTheme'),
        options: this.$ColorTheme.getOptions(),
        formatDisplay: data => data?.name || '',
        successText: this.$t('profile.modify'),
      })
      if (!prompt.accepted || !prompt.data) return
      this.$ColorTheme.changeTheme(prompt.data.id)
    },
    async setLanguage() {
      const prompt = await window.choicePrompt({
        title: this.$t('profile.modifyLanguage'),
        options: this.$Translate.getOptions(),
        formatDisplay: data => data?.name || '',
        successText: this.$t('profile.modify'),
      })
      if (!prompt.accepted || !prompt.data) return
      this.$Translate.changeLang(prompt.data.id)
    },
    rechargeHelpClick() {
      this.requestContentDisplay(
        'Comment faire un dépot via King Recharge',
        'rechargeVideoLink',
        'rechargeTutorialLink',
      )
    },
    withdrawHelpClick() {
      this.requestContentDisplay(
        'Comment faire des retrait via King Recharge',
        'withdrawVideoLink',
        'withdrawTutorialLink',
      )
    },
    async requestContentDisplay(title, videoKey, tutoKey) {
      const contentToShow = await this.requestTypeOfHelpToShow(title)
      if (!contentToShow) return
      let requestedContentLink = null
      if (contentToShow == 'video')
        requestedContentLink = this.addresses?.metaData[videoKey]
      if (contentToShow == 'tutorial')
        requestedContentLink = this.addresses?.metaData[tutoKey]
      if (!requestedContentLink)
        this.$Events.dispatchEvent('toast_notification', {
          title: this.$t('profile.contentNotAvailableTitle'),
          body: this.$t('profile.contentNotAvailableBody'),
        })
      else {
        window.open(requestedContentLink, '_blank')
      }
    },

    async requestTypeOfHelpToShow(title) {
      const acocuntIdsPreferencesConfig = [
        {
          title: this.$t('profile.helpContentDocumentOption'),
          name: 'tutorial',
        },
        {
          title: this.$t('profile.helpContentVideoOption'),
          name: 'video',
        },
      ]
      const prompt = await window.choicePrompt({
        title: title,
        options: acocuntIdsPreferencesConfig,
        formatDisplay: data => data?.title || '',
        successText: this.$t('profile.continue'),
      })
      if (!prompt.accepted || !prompt.data) return null
      return prompt.data.name
    },
    updateUserCountry() {
      const userCountry = this.$Countries.getPhoneCountry(
        this.userData.phoneNumber,
      )
      if (!userCountry) return
      this.userCountry = userCountry
    },
    async editPhoneNumber() {
      const prefix = this.userCountry.phonePrefix
      const phoneWithoutPrefix =
        this.userData?.metaData?.phoneNumber.substring(3)
      const prompt = await window.customPrompt({
        title: 'Modifier votre numéro',
        subTitle: 'Entrez le nouveau numéro de téléphone à utiliser',
        formFields: [
          {
            type: 'number',
            propertyName: 'phoneNumber',
            label: 'Numéro de téléphone',
            defaultValue: phoneWithoutPrefix,
            required: true,
            inputProps: {
              allowTrailingZero: true,
              prefix: prefix,
            },
          },
        ],
        successText: 'Modifier',
      })
      if (!prompt.accepted) return
      this.$Events.dispatchEvent('update_user_data', {
        phoneNumber: `${prefix}${prompt.data.phoneNumber}`,
      })
    },
  },
  computed: {
    appsContentsFiltered() {
      return this.appsContents.filter(
        el => !!(this.appInfo?.metaData || {})[el.id],
      )
    },
  },
})
</script>
